<template>
	<div class="space-y-1">
		<div
			v-for="item in items"
			:key="item.key"
			class="bg-base-100 flex flex-row items-center gap-2 rounded px-2 py-1.5">
			<span
				class="badge badge-sm shrink-0"
				:class="item.alert ? 'badge-error' : item.warn ? 'badge-warning' : 'badge-success badge-outline'">
				{{ item.alert ? t('alerts.widget.alert') : item.warn ? t('alerts.widget.warn') : t('alerts.widget.ok') }}
			</span>
			<span class="min-w-0 flex-1 truncate text-sm font-medium">{{ item.name }}</span>
			<small class="text-base-content/50 shrink-0 whitespace-nowrap text-xs">
				{{ formatDate(item.alert ? item.lastAlertDate : item.lastWarnDate) }}
			</small>
		</div>

		<p v-if="!items.length" class="text-base-content/60 py-8 text-center text-sm">
			{{ t('alerts.widget.empty') }}
		</p>
	</div>
</template>

<script setup lang="ts">
	import { onMounted } from 'vue'
	import dayjs from 'dayjs'
	import { useI18n } from 'vue-i18n'
	import { useAlerts } from './useAlerts'
	import { _translations } from './_translations'

	// Kompakte Status-Liste der konfigurierten Alarme/Warnungen des offenen
	// Graphen (Alarm / Warnung / OK). Gemeinsam genutzt vom AlertWidget-Panel
	// und dem Alarme-Reiter im Alert-Flags-Modal.
	const { t } = useI18n(_translations)
	const alertsApi = useAlerts()
	const items = alertsApi.configuredAlerts

	// Timestamps kommen je nach Quelle in Sekunden oder Millisekunden — beides abfangen.
	const formatDate = (value?: number) => {
		if (!value) return ''
		const ms = value < 1e12 ? value * 1000 : value
		const date = dayjs(ms)
		return date.isValid() ? date.format('DD.MM. HH:mm') : ''
	}

	onMounted(() => {
		void alertsApi.init()
	})
</script>
